/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Seo from "../components/seo"
import Header from "./header"
import Footer from "./footer"
import { useIntl } from "gatsby-plugin-intl"
import "./layout.css"
import { isBrowser } from '../utils'

const Layout = ({ children }) => {
  const intl = useIntl()
  if (isBrowser()) {
    window.__intl = intl
  }
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Seo title={intl.formatMessage({ id: 'global.menu.partner' })} />
      <Header />
      <div>
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
